import React from "react";

import logo from "../images/logo.png";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="bg-black bg-opacity-60 shadow-md">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img
            width={50}
            src={logo}
            alt="Winik Properties Logo"
            className="object-cover"
          />
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
